import { render, staticRenderFns } from "./StaffsList.vue?vue&type=template&id=808ee358&scoped=true&"
import script from "./StaffsList.vue?vue&type=script&lang=js&"
export * from "./StaffsList.vue?vue&type=script&lang=js&"
import style0 from "./StaffsList.vue?vue&type=style&index=0&id=808ee358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808ee358",
  null
  
)

export default component.exports